// 日本語
export default {
	common: {
		requestFailed: 'リクエストに失敗しました',
		needLogin: 'ログインが必要です',
		accountLoggedOut: 'アカウントはログアウトされました',
		confirm: '確認',
		cancel: 'キャンセル',
	},
	nav: {
		home: 'ホーム',
		list: 'リスト',
		game: '検証済み',
		video: '映画',
		mine: '自分',
	},
	route: {
		home: 'ホーム',
		choose: '相手選び',
		list: '相手リスト',
		profile: '詳細情報',
		mine: 'マイページ',
		video: '動画',
		game: 'ゲーム',
		login: 'ログイン',
		register: '新規登録',
		serviceOnline: 'オンラインサービス',
		servicePage: 'オンラインサービス',
		setting: '設定',
		infomation: '基本情報',
		setname: '本名の変更',
		setsex: '性別の変更',
		setPayPassword: '支払いパスワード管理',
		setLoginPassword: 'ログインパスワード管理',
		lottery: '詳細ページ',
		notice: 'お知らせ',
		playVideo: '動画再生',
		setbank: '受取口座情報の入力',
		bindCard: '銀行口座の紐付け',
		withdraw: '出金',
		personalreport: '個人レポート',
		withdrawRecord: '出金履歴',
		gameRecord: 'タスク履歴',
	},
	page: {
		login: {
			title: 'ログイン',
			usernamePlaceholder: 'ユーザー名を入力',
			passwordPlaceholder: 'パスワードを入力',
			forgotPassword: 'パスワードをお忘れですか？',
			registerPrompt: 'アカウントをお持ちでない方は今すぐ登録',
			loginBtn: 'ログイン',
			enterUsername: 'ユーザー名を入力してください！',
			enterPassword: 'パスワードを入力してください！',
		},
		mine: {
			recharge: 'チャージ',
			withdraw: '出金',
			myWallet: 'マイウォレット',
			detail: '明細',
			balance: '残高',
			personalReport: '個人レポート',
			accountDetail: 'アカウント明細',
			taskRecord: 'タスク記録',
			profileCenter: 'プロフィールセンター',
			notice: 'お知らせ',
			onlineService: 'オンラインサービス',
			refreshSuccess: '更新しました',
			exitTaskWarn: 'タスクを完了してから退出してください',
			rechargeContactService: 'チャージはカスタマーサービスまでお問い合わせください',
			setBankCardFirst: '先に受取口座情報を設定してください！',
			functionDisabled: '機能は無効化されています！',
			guestUsername: 'ログイン / 新規登録',
			guestSubtitle: 'ログインしてより多くのサービスを体験！',
		},
		setting: {
			navTitle: '設定',
			basicInfoSetting: '基本情報設定',
			loginPassword: 'ログインパスワード',
			payPassword: '支払いパスワード',
			payPasswordSet: '設定済み',
			payPasswordUnset: '未設定',
			logout: 'ログアウト',
			payPasswordAlreadySet: '出金パスワードは設定済みです。変更する場合はカスタマーサービスまでお問い合わせください',
			language: '言語を切り替える',
		},
		infomation: {
			navTitle: '基本情報',
			avatar: 'アバター',
			selectAvatar: 'アバターを選択',
			realName: '本名',
			notSet: '未設定',
			gender: '性別',
			genderUndefined: '未確認',
			male: '男性',
			female: '女性',
			bankBinding: '銀行口座紐付け',
			linked: '紐付け済み',
			none: 'なし',
		},
		setname: {
			navTitle: '本名の変更',
			save: '保存',
			name: '名前',
			namePlaceholder: '本名を入力してください',
			nameWarn: 'アカウントの安全を確保するため、本名は紐付けた銀行口座の名前と一致する必要があります',
			dontSetAgain: '再設定しないでください！',
			enterName: '名前を入力してください！',
		},
		setsex: {
			navTitle: '性別の変更',
			male: '男性',
			female: '女性',
		},
		setPayPassword: {
			navTitle: '支払いパスワードの設定',
			enterPassword: '支払いパスワードを入力',
			confirmPassword: '支払いパスワードを再入力',
			fillComplete: 'すべて入力してください',
			passwordMismatch: 'パスワードが一致しません！',
		},
		setLoginPassword: {
			navTitle: 'ログインパスワードの変更',
			save: '保存',
			oldPassword: '現在のパスワード',
			oldPasswordPlaceholder: '現在のパスワードを入力してください',
			newPassword: '新しいパスワード',
			newPasswordPlaceholder: '新しいパスワードを入力してください',
			confirmPasswordPlaceholder: '新しいパスワードを再入力してください',
			fillComplete: 'すべての項目を入力してください！',
			passwordMismatch: '2回のパスワードが一致しません',
		},
		notice: {
			navTitle: 'システムお知らせ',
			refreshSuccess: '更新しました',
		},
		serviceOnline: {
			navTitle: 'オンラインサービス',
			contact: 'お問い合わせ',
			serviceHours: '7日間24時間対応',
		},
		servicePage: {
			navTitle: 'カスタマーサービス',
		},
		withdraw: {
			navTitle: '出金センター',
			history: '出金履歴',
			amount: '出金金額',
			all: 'すべて',
			limit: '出金限度額',
			limitPerTransaction: '1. 1回の出金限度：最小 {min}、最大 {max}',
			limitPerDay: '2. 出金回数：1日最大 {num} 回',
			transferTime: '3. 振込時間：通常約5分、最速2分以内',
			balanceLabel: '残高：',
			withdrawNow: '今すぐ出金',
			enterCorrectAmount: '正しい金額を入力してください',
		},
		withdrawRecord: {
			navTitle: '出金履歴',
			noData: 'データがありません！',
			amount: '金額：',
			info: '情報：',
			submitTime: '申請時間：',
			auditTime: '審査時間：',
			refreshSuccess: '更新しました',
		},
		bindCard: {
			navTitle: '受取口座情報の入力',
			label: '受取口座情報を入力してください',
			accountNumber: '口座番号',
			accountPlaceholder: '銀行口座番号を入力してください',
			bank: '銀行',
			bankPlaceholder: '銀行を選択してください',
			warn: 'ユーザーの皆様、資金の安全を確保するため、本名の紐付けと出金パスワードの設定をお願いします。名前が口座名義と一致しない場合、出金できません。',
			confirmBind: '口座紐付けを確認',
			enterCardNumber: 'カード番号を入力してください！',
			selectBank: '銀行を選択してください！',
		},
		setbank: {
			navTitle: 'カード情報',
			addCard: '出金用カード情報を追加',
			tip: 'ヒント：大型商業銀行に紐付けてください。変更する場合はオンラインサービスまでお問い合わせください',
			setNameFirst: '銀行口座を紐付ける前に本名を設定してください！',
			setPayPasswordFirst: '銀行口座を紐付ける前に出金パスワードを設定してください！',
		},
		personalreport: {
			navTitle: '個人レポート',
			profitTitle: '損益金額',
			profitFormula: '損益公式：当選金額 - 賭け金額',
			taskMoney: '賭け金額',
			rechargeMoney: 'チャージ金額',
			withdrawMoney: '出金金額',
			winMoney: '当選金額',
		},
		gameRecord: {
			navTitle: 'タスク履歴',
			noData: 'データがありません！',
			betAmount: '賭け金額：',
			betTime: '賭け時間：',
			updateTime: '更新時間：',
			refreshSuccess: '更新しました',
			kim: '金',
			moc: '木',
			thuy: '水',
			hoa: '火',
		},
		home: {
			recommendTask: 'おすすめタスク',
			viewMore: 'もっと見る',
			popularRanking: '人気ランキング',
			hotRecommend: 'おすすめ',
			playCount: '再生：',
			loadingData: 'データを取得中...',
			refreshSuccess: '更新しました',
		},
		choose: {
			navTitle: 'デートしたいですか？',
			city: '都市',
			cityDesc: 'コミュニティは最も信頼できるプラットフォームで、最も信頼できる情報を共有しています。私たちはお客様に信頼できる、健全でプライバシーが保護された場所を提供することをお約束します。',
			processAndPrice: 'プロセスと料金',
			processDesc: 'このウェブサイトは、同都市内の外周サービス、ビジネス同行、感情関連サービスを提供しています。各ユーザーのプライバシーを保護するため、お客様は受付スタッフまたはプラットフォームの上級メンバーに連絡することでのみ参加できます。',
			resourcesTitle: 'どのようなリソースがありますか？',
			resourcesContent: '有名な芸能人、モデル、客室乗務員、若手モデル、大学生など、このプラットフォームで不可能なことはありません',
			serviceScopeTitle: 'サービス範囲？',
			serviceScopeContent1: '同都市内での無料デート、全国のすべての場所をカバーし、主要都市に対応しています。受付スタッフに連絡して手配することもできます。',
			serviceScopeContent2: 'このウェブサイトは、同都市内の外周サービス、ビジネス同行、感情関連サービスを提供しています。各ユーザーのプライバシーを保護するため、お客様は受付スタッフまたはプラットフォームの上級メンバーに連絡することでのみ参加できます。',
		},
		list: {
			refreshSuccess: '更新しました',
		},
		profile: {
			navTitle: '選択',
			bookAppointment: '予約する',
			contactConsultant: 'コンサルタントまたは受付にお問い合わせください',
		},
		video: {
			navTitle: 'シネマ',
			noMore: 'これ以上ありません',
			playCount: '再生：',
			refreshSuccess: '更新しました',
		},
		playVideo: {
			playCount: '回再生',
			hotRecommend: 'おすすめ',
			rechargeToWatch: '動画を視聴するには先にチャージしてください！',
		},
		game: {
			navTitle: '投票ロビー',
			all: 'すべて',
			refreshSuccess: '更新しました',
		},
		register: {
			title: '新規登録',
			usernamePlaceholder: 'ユーザー名を入力（6〜12文字の英数字）',
			passwordPlaceholder: 'パスワードを入力（6〜12文字の英数字）',
			codePlaceholder: '招待コードを入力',
			agreementText: '「アカウント契約」の条件を読み、同意しました',
			registerBtn: '登録',
			enterUsername: 'ユーザー名を入力してください！',
			enterPassword: 'パスワードを入力してください！',
			enterCode: '招待コードを入力してください！',
			agreeTerms: '以下の条件に同意してください！',
		},
		lottery: {
			taskHistory: 'タスク履歴',
			rules: 'ゲームルール',
			playHint: '遊び方のヒント',
			playHintDetail: '選択可能な形式と数値から数字を選んで賭けます',
			prizeGuide: '当選ガイド',
			prizeGuideDetail: '3つの当選数字の合計が11〜18は「大」、3〜10は「小」です；',
			betExample: '賭けの例',
			betExampleDetail: '賭けの例：小 当選結果：123 → 小で当選',
			taskOrder: 'タスク注文',
			availableBalance: '利用可能残高',
			currency: '分数',
			submit: '送信',
			currentChoice: '現在の選択：',
			betAmount: '賭け金額：',
			enterAmount: '金額を入力',
			selected: '選択済み',
			total: '合計',
			orderDetail: '1 x {money}đ = {money}',
			clearOrder: '注文をクリア',
			confirmSubmit: '送信を確認',
			periodNumber: '期号',
			resultNumber: '当選番号',
			notSelected: '未選択',
			invalidAmount: '金額が無効です！',
			selectNumber: '数字を選択してください！',
			enterAmountWarn: '金額を入力してください！',
			insufficientBalance: '残高不足です。チャージするにはカスタマーサービスまでお問い合わせください！',
			refreshSuccess: '更新しました',
			contactAdminForTask: 'このタスクを受け取るには管理者に連絡してください！',
			lotteryResultPeriod: '当選結果、期号：{period}',
		},
		ordlan: {
			"PopularMembers": "人気メンバー",
			    "Rating": "評価",
			    "AppointmentRequest": "予約リクエスト",
			    "PersonalVideoVerification": "個人ビデオ認証",
			    "IdentityVerification": "本人確認",
			    "ManagerProfile": "管理者プロフィール",
			    "ServiceArea": "サービスエリア",
			    "TravelAvailable": "出張可能",
			    "Yes": "はい",
				help:'ヘルプ',
				AgencyBooking:'代理店予約',
				More:'詳細',
		}
	},
}
